import type { CSSObject } from "@mui/material";

export const clampLinesSx = (lines: number | "unset"): CSSObject => ({
	display: "-webkit-box",
	WebkitBoxOrient: "vertical",
	WebkitLineClamp: lines,
	overflow: "hidden",
	textOverflow: "ellipsis",
});
